import type { LinkDef } from '@hanzo/ui/types'

export default [
  {
    title: 'Company',
    href: "https://lux.partners/",
    variant: 'linkFG',
    newTab: false,
  },
  {
    title: 'About',
    href: 'https://lux.partners',
    newTab: false,
  },
  {
    title: 'Brand',
    href: 'https://drive.google.com/drive/folders/14OJtKLVakGY6883XO9yGbiHtlFxQUUm5?usp=share_link',
  },
  {
    title: 'Careers',
    href: 'https://docs.google.com/document/d/1SCt0Hg7EIs06TootKCA1am1xo4mcXoKF/edit#heading=h.30j0zll',
    newTab: true,
  },
  {
    title: 'Partnerships',
    href: 'https://apply.lux.partners/',
    newTab: false,
  },
  {
    title: 'Press',
    href: 'mailto:ai@lux.partners?subject=%E2%96%BC%20Press',
  },
  {
    title: 'Help',
    href: 'mailto:ai@lux.partners?subject=%E2%96%BC%20Help',
  },
] satisfies LinkDef[]
